import { useMemo, useEffect, useRef } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import { CustomHeaderColumn } from '../table/columns/CustomHeaderColumn'
import { CustomRow } from '../table/columns/CustomRow'
import { useQueryResponseData, useQueryResponseLoading } from '../core/QueryResponseProvider'
import { usersColumns } from './columns/_columns'
import { User } from '../core/_models'
import { UsersListLoading } from '../components/loading/UsersListLoading'
import { UsersListPagination } from '../components/pagination/UsersListPagination'
import { KTCardBody } from '../../../../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../../../auth'

interface UserProps {
  columnProps?: any
  mockedData?: any
  showPagination?: boolean
  initialApi?: any
}

const UsersTable = ({
  showPagination = false,
  initialApi,
  columnProps,
  mockedData = [],
}: UserProps) => {
  const { pathname } = useLocation()
  const { currentUser } = useAuth()
  const users = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => users, [users])
  const columns = useMemo(() => columnProps || usersColumns, [columnProps])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data: mockedData.length ? mockedData : data,
  })

  const isSponsorRetiredPage = pathname.includes('/apps/plastic-credits/retired') && (currentUser as any)?.userType === 'SPONSOR';

  const tableRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    let animationId: number
    let scrollDirection = 0

    const handleMouseMove = (e: MouseEvent) => {
      if (!tableRef.current) return

      const scrollContainer = tableRef.current
      const containerRect = scrollContainer.getBoundingClientRect()
      const edgeThreshold = 50 // Distance from edge to trigger scroll

      // Check if mouse is near left or right edge of the container
      if (e.clientX <= containerRect.left + edgeThreshold) {
        scrollDirection = -1 // Scroll left
      } else if (e.clientX >= containerRect.right - edgeThreshold) {
        scrollDirection = 1 // Scroll right
      } else {
        scrollDirection = 0 // Stop scrolling
      }
    }

    const handleMouseLeave = () => {
      scrollDirection = 0 // Stop scrolling when mouse leaves
    }

    const smoothScroll = () => {
      if (scrollDirection !== 0 && tableRef.current) {
        const scrollSpeed = 3 // Reduced speed for smoother scrolling
        tableRef.current.scrollLeft += scrollDirection * scrollSpeed
      }
      animationId = requestAnimationFrame(smoothScroll)
    }

    const tableContainer = tableRef.current
    if (tableContainer) {
      tableContainer.addEventListener('mousemove', handleMouseMove)
      tableContainer.addEventListener('mouseleave', handleMouseLeave)
      smoothScroll() // Start the smooth scroll loop

      return () => {
        tableContainer.removeEventListener('mousemove', handleMouseMove)
        tableContainer.removeEventListener('mouseleave', handleMouseLeave)
        cancelAnimationFrame(animationId)
      }
    }
  }, [])



  return (
    <KTCardBody className='py-4'>
      {isSponsorRetiredPage && (
        <style>{`
   #kt_table_wusers thead tr th {
     background-color: #ffffff !important;
     color: #99a1b7 !important;
     font-weight: 600 !important;
   }
 `}</style>
      )}
      {/* <div className='table-responsive'>
        <table
          id='kt_table_wusers'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        > */}

      <div className='table-responsive' ref={tableRef}>
        <table
          id='kt_table_wusers'
          className='table align-middle table-row-solid fs-7 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          {/* <thead>
            <tr className={`text-left fw-bolder fs-7  gs-0 ${isSponsorRetiredPage ? '' : 'text-white'
              }`}>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead> */}


          {/* <thead>
            <tr className={`text-left fw-bolder fs-7 gs-0 ${isSponsorRetiredPage
              ? ''
              : 'text-white '
              }`}>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead> */}


          <>
            <style>{`
    thead.custom-dark-thead,
    thead.custom-dark-thead tr,
    thead.custom-dark-thead tr th {
      background-color: #000000 !important;
      background: #000000 !important;
      background-image: none !important;
      font-weight: 700 !important;
      color: #ffffff !important;
      font-size: 11px !important;
      letter-spacing: 0.5px;
      padding-top: 16px !important;
      padding-bottom: 16px !important;
      padding-left: 15px !important;
      padding-right: 15px !important;
      border: none !important;
    }
    thead.custom-dark-thead tr th:first-child {
      border-top-left-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
    }
    thead.custom-dark-thead tr th:last-child {
      border-top-right-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
    }
    #kt_table_wusers {
      border-collapse: separate;
      border-spacing: 0;
    }
    #kt_table_wusers tbody tr td {
      border-bottom: 1px solid #EEF0F3;
      padding: 15px 10px;
    }
  `}</style>

            <thead className="custom-dark-thead">
              <tr className={`text-left fw-bolder fs-7 gs-0 ${isSponsorRetiredPage
                ? ''
                : 'text-white'
                }`}>
                {headers.map((column: ColumnInstance<User>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
              </tr>
            </thead>
          </>


          <tbody className='text-gray-600 ' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              <>
                {rows.map((row: Row<User>, i) => {
                  prepareRow(row)
                  return <CustomRow row={row} key={`row-${i}-${row.id}`} />
                })}
              </>
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showPagination && <UsersListPagination initialApi={initialApi} />}
      {isLoading && <UsersListLoading />}
    </KTCardBody>
  )
}

export { UsersTable }